// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
export const supportedMonitorCatalog = Object.freeze([
  Object.freeze({ make: "Garmin", model: "G1000", parserId: "garmin-g1000" }),
  Object.freeze({ make: "Garmin", model: "TXi", parserId: "garmin-txi" }),
  Object.freeze({ make: "Garmin", model: "GI 275 EIS", parserId: "garmin-g1000" }),
  Object.freeze({ make: "Garmin", model: "G3X Touch", parserId: "garmin-user-log" }),
  Object.freeze({ make: "Dynon", model: "SkyView", parserId: "dynon-skyview" }),
  Object.freeze({ make: "Advanced Flight Systems", model: "AF-5000", parserId: "advanced-flight" }),
  Object.freeze({ make: "JPI", model: "EDM-350", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-700", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-730", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-760", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-790", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-800", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-830", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-900", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-930", parserId: "jpi-binary" }),
  Object.freeze({ make: "JPI", model: "EDM-960", parserId: "jpi-binary" }),
  Object.freeze({ make: "Insight", model: "G2", parserId: "insight" }),
  Object.freeze({ make: "Insight", model: "G3", parserId: "insight-g3" }),
  Object.freeze({ make: "Insight", model: "G4 twin", parserId: "insight-g4-twin" }),
  Object.freeze({ make: "Electronics International", model: "CGR-30P", parserId: "ei-cgr" }),
  Object.freeze({ make: "Electronics International", model: "CGR-30C", parserId: "ei-cgr-30c" }),
  Object.freeze({ make: "Electronics International", model: "CGR-30P + 30C", parserId: "ei-cgr-combo" }),
  Object.freeze({ make: "Electronics International", model: "MVP-50P", parserId: "ei-mvp" }),
]);

export function supportedMonitorMakes() {
  return [...new Set(supportedMonitorCatalog.map((monitor) => monitor.make))];
}

export function supportedMonitorModelsForMake(make) {
  const selectedMake = String(make ?? "").trim();
  return supportedMonitorCatalog
    .filter((monitor) => monitor.make === selectedMake)
    .map((monitor) => monitor.model);
}

export function supportedMonitorByMakeModel(make, model) {
  const selectedMake = String(make ?? "").trim();
  const selectedModel = String(model ?? "").trim();
  return supportedMonitorCatalog.find((monitor) => monitor.make === selectedMake && monitor.model === selectedModel) ?? null;
}

export function supportedMonitorFromLabel(value) {
  const label = String(value ?? "").trim().replace(/\s+/g, " ");
  if (!label) return null;
  const exact = supportedMonitorCatalog.find((monitor) => supportedMonitorLabel(monitor).toLowerCase() === label.toLowerCase());
  if (exact) return exact;

  const jpiModel = label.match(/\bEDM[-\s]?(350|700|730|760|790|800|830|900|930|960)\b/i)?.[1];
  if (jpiModel) return supportedMonitorByMakeModel("JPI", `EDM-${jpiModel}`);

  if (/\bG1000\b/i.test(label)) return supportedMonitorByMakeModel("Garmin", "G1000");
  if (/\bTXi\b/i.test(label)) return supportedMonitorByMakeModel("Garmin", "TXi");
  if (/\bGI\s*275\b/i.test(label)) return supportedMonitorByMakeModel("Garmin", "GI 275 EIS");
  if (/\bG3X\b/i.test(label)) return supportedMonitorByMakeModel("Garmin", "G3X Touch");
  if (/\bG4\b/i.test(label) && /\bInsight\b/i.test(label)) return supportedMonitorByMakeModel("Insight", "G4 twin");
  if (/\bG3\b/i.test(label) && /\bInsight\b/i.test(label)) return supportedMonitorByMakeModel("Insight", "G3");
  if (/\bG2\b/i.test(label) && /\bInsight\b/i.test(label)) return supportedMonitorByMakeModel("Insight", "G2");
  if (/\bCGR[-\s]?30P\b/i.test(label) && /\b30C\b/i.test(label)) return supportedMonitorByMakeModel("Electronics International", "CGR-30P + 30C");
  if (/\bCGR[-\s]?30P\b/i.test(label)) return supportedMonitorByMakeModel("Electronics International", "CGR-30P");
  if (/\bCGR[-\s]?30C\b/i.test(label)) return supportedMonitorByMakeModel("Electronics International", "CGR-30C");
  if (/\bMVP[-\s]?50P\b/i.test(label)) return supportedMonitorByMakeModel("Electronics International", "MVP-50P");

  if (/\bAdvanced Flight\b|\bAdvanced Flight Systems\b|\bAF[-\s]?5000\b/i.test(label)) return supportedMonitorByMakeModel("Advanced Flight Systems", "AF-5000");
  if (/\bSkyView\b/i.test(label) || /\bDynon\b/i.test(label)) return supportedMonitorByMakeModel("Dynon", "SkyView");
  if (/\bGarmin\b/i.test(label) && !/\buser\s+log\b/i.test(label)) return { make: "Garmin", model: "", parserId: "garmin-user-log" };
  if (/\bJPI\b/i.test(label)) return { make: "JPI", model: "", parserId: "jpi-csv" };
  if (/\bInsight\b/i.test(label)) return { make: "Insight", model: "", parserId: "insight" };
  if (/\bAdvanced Flight\b|\bAFS\b/i.test(label)) return { make: "Advanced Flight Systems", model: "", parserId: "advanced-flight" };
  if (/\bElectronics International\b|\bEI\b/i.test(label)) return { make: "Electronics International", model: "", parserId: null };
  return null;
}

export function supportedMonitorFromParser(parserId) {
  if (parserId === "garmin-user-log") return null;
  if (parserId === "jpi-binary" || parserId === "jpi-csv") return { make: "JPI", model: "", parserId };
  return supportedMonitorCatalog.find((entry) => entry.parserId === parserId) ?? null;
}

export function supportedMonitorLabel(monitor) {
  if (!monitor) return "";
  return [monitor.make, monitor.model].filter(Boolean).join(" ").trim();
}

export function displayMonitorLabel(value) {
  const label = String(value ?? "").trim();
  if (!label) return "";
  return label.replace(/^Electronics International\b/, "EI");
}

export function monitorLabelForParser(parserId) {
  if (parserId === "garmin-user-log") return "Session Time CSV";
  if (parserId === "jpi-binary") return "JPI EDM raw";
  if (parserId === "jpi-csv") return "JPI decoded CSV";
  const monitor = supportedMonitorCatalog.find((entry) => entry.parserId === parserId);
  return supportedMonitorLabel(monitor) || null;
}
